// 星春大吉 - 熱門座位
'use client';

import { OFFICIAL_URL } from '@/common/constant';
import { useSelector } from 'react-redux';
import { urlState } from '@/slices/urlSlice';

const LunarYearPopular = () => {
    const { forumUrl } = useSelector(urlState);

    return (
        <div className="mt-[30px] relative">
            <img src={OFFICIAL_URL.LUNAR_YEAR_CDN_BASE + 'check.png'} alt="seat" />

            <a
                href={forumUrl + `/topics/lunar-new-year-2026`}
                className="absolute left-[50%] translate-x-[-50%] w-[70%] bottom-[20%] z-[1] trans hover:opacity-[.7]"
            >
                <img src={OFFICIAL_URL.LUNAR_YEAR_CDN_BASE + 'check_button.png'} alt="check" />
            </a>
        </div>
    );
};

export default LunarYearPopular;
